export default __webpack_public_path__ + "static/media/Product-Stock.83b7eb54.jpg";